/*
 * @Description: 路由跳转控制中心
 * @Author: 任录
 * @Date: 2019-07-22 15:13:52
 * @LastEditTime: 2019-07-26 22:38:03
*/

import Vue from 'vue'
import Router from 'vue-router'

import aboutRoutes from './about'
import addRoutes from './add'
import contactRoutes from './contact'
import customerRoutes from './customer'
import homeRoutes from './home'
import productRoutes from './product'
import salesManagement from './product1'
import inputManagemen  from './product2'
import reimburseManagemen  from'./product3'
import oCRDistinguish  from'./product4'
import invoicecheck   from'./product5'
import taxManangerPlatForm from './product6'
import electronicArchives  from './product7'
import solutionRoutes from './solution'
import errorRoutes from './error'
import bulleFtrame from './bulleFtrame'
import salement from './salesmanager'
import prodectManage from './prodectManage'
import technician  from './technician'
import taxSharingPlatform from './product8.js'
import allkindsofTaxAdministration from './product9.js'
import personalIncomeTaxManagement from './product10.js'
import caseIntroduction from './caseIntroduction.js'
//成功案例的路由内容设置
import  cgal_hntv from './cgal_hntv'// 河南一建

import  cgal_hnej from './cgal_hnej'// 河南二建

import  cgal_hnwj  from './cgal_hnwj'  // 河南五建

import  cgal_hbjs  from './cgal_hbjs'  // 河北建设

import  cgal_jzdx from  './cgal_jzdx'  //焦作大学

import  cgal_hnws from  './cgal_hnws'  //湖南省外事侨务办公室出国（境）服务中心






Vue.use(Router)

const children = [...aboutRoutes, ...customerRoutes, ...homeRoutes, ...productRoutes, ...solutionRoutes, ...addRoutes,...contactRoutes
,...salesManagement,...inputManagemen,...reimburseManagemen,...oCRDistinguish,...invoicecheck,...taxManangerPlatForm,...electronicArchives,
...bulleFtrame,...salement,...prodectManage,...technician,...taxSharingPlatform,...allkindsofTaxAdministration,...personalIncomeTaxManagement,...caseIntroduction,
...cgal_hntv,...cgal_hnej,...cgal_hnwj ,...cgal_hbjs,...cgal_jzdx,...cgal_hnws]

const router = new Router({
  // mode: 'history',
  mode: 'hash',
  base:'/guanwang/',  
  routes: [
    {
      path: '/',
      name: '',
      component: resolve => require(['@/views/Main'], resolve),
      children
    },
    ...errorRoutes
  ]
})

router.beforeEach((to, from, next) => {
    window.scroll(0,0);
    next();
})

export default router

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js